import axios from 'axios'
import constants from '../../../constants'

const getCorpChildrenMedication = async (customerNumber: string, queryParams?: string) => {
  const query = queryParams ?? ''
  const { data } = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer-medications/corp-children${query}`)
  return data
}

export { getCorpChildrenMedication }